import { render, staticRenderFns } from "./GameInstance.vue?vue&type=template&id=beac3e7a&scoped=true"
import script from "./GameInstance.vue?vue&type=script&lang=js"
export * from "./GameInstance.vue?vue&type=script&lang=js"
import style0 from "./GameInstance.vue?vue&type=style&index=0&id=beac3e7a&prod&scoped=true&lang=css"
import style1 from "./GameInstance.vue?vue&type=style&index=1&id=beac3e7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beac3e7a",
  null
  
)

export default component.exports